import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../../hooks/hooks";
import { selectLMSCertificatesListItems } from "../../../../../redux/lms/certificates/selector";
import { lmsCertificates } from "../../../../../redux/lms/certificates/action";
import PageLoader from "../../../../../components/PageLoader";
import Table from "../../../../../common/components/table-manager/v1.1/table";

const CandidateLMScertificates = () => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [pageData, setPageData] = useState(1)
    const [pageSize, setPageSize] = useState(10);
    const lmsCertificatesItemsData = useSelector(selectLMSCertificatesListItems)
    const [columnDefs, setColumnDefs] = useState({});

    const createColumnDefs: any = () => {
        setColumnDefs([
            {
                field: 'Sl',
                sortable: false,
                filter: false,
                isSortLabel: true,
                headerName: 'Sl',
                cellRenderer(params: any) {
                    return parseInt(
                        params.node.id,
                        10
                    ) + 1;
                },
            },
            { field: 'Name', headerName: 'Name',searchField: 'Name', sortable: true, filter: true, filterType: 'text' },
            { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true },
            { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true },
        ]);
    }

    const fetchLMSCertificatesList = () => {
        dispatch(lmsCertificates.list({
            url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/certificates/list`,
            entity: 'lmsCertificates',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc"
            }
        }))
    }

    useEffect(() => {
        createColumnDefs()
        fetchLMSCertificatesList()
    }, [pageData, pageSize])


    const handleAdd = () => {
        navigate(`${0}`)
    }

    

    const handleDelete = (data: any) => {
        dispatch(lmsCertificates.delete({
            url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/certificates/delete`,
            entity: 'lmsCertificates',
            jsonData: {
                records: [
                    {
                        id: data?.Id
                    }
                ]
            }
        })).then(() => {
            fetchLMSCertificatesList()
        });
    }
    const handleEdit = (data: any) => {
        navigate(`${data?.Id}`)
      }
      const handleReloadData = () => {
        fetchLMSCertificatesList()
      }
      const additionButtons: any = [
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24">
              <title>Add Certificate</title>
              <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
            </svg>,
          callback: () => handleAdd(),
        },
        
        {
          svg:
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
              <title>Reload this table</title>
              <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>,
          callback: () => handleReloadData(),
        },
      ];
    
      const handleSearch = (data: any) => {
        let searchCriteria = {};
        if (data?.column) {
          searchCriteria = [{
            FieldName: data?.column,
            FieldText: data?.column,
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } else {
          searchCriteria = [{
            FieldName: "Name",
            FieldText: "Name",
            FieldType: 'text',
            FilterOperatorId: 6,
            FieldValue: data?.value
          }]
        } 

        dispatch(lmsCertificates.list({
            url: `https://skill.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/lms/certificates/list`,
            entity: 'lmsCertificates',
            jsonData: {
                "PageNumber": pageData,
                "PageSize": pageSize,
                "SortField": "Id",
                "SortOrder": "desc",
                "Searches": searchCriteria,
              }
        }))
    }


    
   
    return (
        <>
            {lmsCertificatesItemsData?.isLoading ?
                <PageLoader /> :
                <Table 
                checkboxConfig={{
                  allowMultiSelect: true,
                  defaultSelectedIds: [],
                  isDisabled: false,
                  keyColumn: 'Id',
                }}
                columnData={columnDefs} rowData={lmsCertificatesItemsData?.result?.items} setPageData={setPageData}
                    setPageSize={setPageSize} paginationData={lmsCertificatesItemsData?.result?.pagination}
                    enableFilter={true} onSearch={handleSearch}  additionButtons={additionButtons} onEdit={handleEdit} onDelete={handleDelete}
                    headingName="Certificates" />
            }
        </>
    );
};

export default CandidateLMScertificates;
